import React from 'react'

const InfoPart = () => {
  return (
    // <div className="info-background">
    <div id="part_info">
      <div className="main_about main_about_flex">
        <div className="container">
          {/* <div className="main_about_order"> */}
          <div className="main_about_title text_shadow">
            Компания ТД СТАЛЬИНВЕСТ вышла на рынок стального проката в 2007
            году.
          </div>
          <div className="main_about_text text_shadow">
            За все эти годы сформировалось основное направление деятельности -
            оптовые поставки качественного металлопроката с металлургических
            заводов и комбинатов.
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  )
}

export default InfoPart
